import { useCallback } from 'react';
import { useIssueTransitionLabsOptIn } from '@atlassian/jira-router-resources-issue-transition-labs-opt-in';
import type {
	IssueTransitionModalPayload,
	OpenIssueTransitionModal,
	State,
	TriggerIssueTransitionModalActions,
} from '../../common/types';
import {
	useTriggerIssueTransitionModalActions,
	useTriggerIssueTransitionModalState,
} from '../../controllers/trigger-issue-transition-modal';

export const useOpenIssueTransitionModal = (): OpenIssueTransitionModal => {
	const { openIssueTransitionModal: openIssueTransitionModalAction } =
		useTriggerIssueTransitionModalActions();
	const { stateGet: { state: { isEnabled = true } = {} } = {} } = useIssueTransitionLabsOptIn();
	return useCallback(
		(nextState?: IssueTransitionModalPayload) => {
			openIssueTransitionModalAction(nextState, isEnabled);
		},
		[isEnabled, openIssueTransitionModalAction],
	);
};

export const useTriggerIssueTransitionModal = (): [State, TriggerIssueTransitionModalActions] => {
	const state = useTriggerIssueTransitionModalState();
	const actions = useTriggerIssueTransitionModalActions();
	const openIssueTransitionModal = useOpenIssueTransitionModal();

	return [state, { ...actions, openIssueTransitionModal }];
};

export default useTriggerIssueTransitionModal;
